import { PropertyRef, defineBool, defineEnum } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

// HackWeek 27 - 31 March 2023
// Second Experiment (4th May)
// The control will show the survey option (ReasonSelector component)
// The target will omit that step.
export enum FeedbackStatus {
  SHOW_SURVEY = 'SHOW_SURVEY',
  DO_NOT_SHOW_SURVEY = 'DO_NOT_SHOW_SURVEY',
  ORIGINAL = 'ORIGINAL',
}

export const showSurveyOptionEnum = defineEnum({
  name: 'showSurveyOption',
  description: 'A/B-test to improve the UX in the FeedbackWidget',
  values: FeedbackStatus,
  default: FeedbackStatus.ORIGINAL,
});

export const s4aLaunchedBool = defineBool({
  name: 's4aLaunched',
  description: 'Boolean to control the S4A Turnkey site visibility',
  default: false,
});

/**
 * Hindi messaging rollout (FA-2973)
 */
export const hindiMessagingBool = defineBool({
  name: 'hindiMessaging',
  description: 'Hindi messaging rollout',
  default: false,
});

export const properties: Array<PropertyRef> = [ubiTestBool, showSurveyOptionEnum, s4aLaunchedBool, hindiMessagingBool];
